module.exports = __webpack_public_path__ + "icons/original/small/small-a4.0ef2cddeeac6822a557e42295feb1e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a4.png
// module id = Htyr
// module chunks = app